import React, { Suspense, useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { ENHANCED_VIEWER } from "src/constants/assets";
import { fetchPreviewAsset, fetchPreviewTextLayer, recordAnalyticsEvent } from "src/redux/actions/assets";

import _ from "lodash";
import cx from "classnames";
import styles from "./assetViewer.module.scss";
import "@paperflite-marketing/asset-viewer/dist/index.css";
import { useMediaQuery } from "react-responsive";

import AuthService from "src/services/auth.service";
import DefaultViewer from "./defaultViewer";

const loadingPlane = '/images/loading_plane.gif';

/* eslint-disable-next-line import/first */
const DocumentViewer = React.lazy(() =>
  import("@paperflite-marketing/asset-viewer").then((module) => ({
    default: module.DocumentViewer,
  })),  
);

const EnhancedDocumentViewer = ({ asset, width, isSidePanelOpen, processingAsset, initialPage, showTableOfContents, setShowTableOfContents }) => {
  const [preferredWidth, setPreferredWidth] = useState(1024);
  const [error, setError] = useState(false);
  const [offset, setOffset] = useState(0);
  const desktop = useMediaQuery({ query: '(min-width: 992px)' })
  const tableOfContent = useSelector((state) => _.get(state, `asset.tableOfContents.sections`,[]));
  

  const preview = useSelector((state) =>
    _.get(state, `asset.assetsPreview[${asset.id}].item`),
  );

  const session = useSelector((state) => _.get(state, "asset.session.id")) || null;

  const dispatch = useDispatch();

  const handleError = (e) => {
    const hasError = preview == null || e.name === "InvalidPDFException";
    if (hasError) {
      setError(true);
    }
  };

  const loadPreviewData = (asset) => {
    if (asset.viewer === ENHANCED_VIEWER) {
      dispatch(fetchPreviewAsset({id:asset.id}));
      dispatch(fetchPreviewTextLayer(asset.id));
    }
  };

  const onPageChange = (page) => {
    var viewDate = new Date().getTime();

    if (session) {
      dispatch(recordAnalyticsEvent({
        type: 101,
        session: session,
        eventDate: viewDate,
        page: page
      }))
    }
  }

  useEffect(() => {
    const offset = desktop ? 50 : 10;
    var widthValue = width - 2 * offset;
    widthValue = Math.min(widthValue, 1024);

    setPreferredWidth(widthValue);
  }, [width, desktop]);


  // Document Toolbar positioning
  useEffect(() => {
    const root = document.querySelector(':root');

    if(isSidePanelOpen) {
      root.style.setProperty('--modal-width', '22rem');
    } else {
      root.style.setProperty('--modal-width', '0rem');
    }
  }, [isSidePanelOpen])
  


  if(error){
    return <DefaultViewer asset={asset} />
  }

  var sourceUrl = asset.previewUrl;
  var source = _.get(asset, 'source');
  const isCloudFrontUrl = _.includes(sourceUrl,"cloudfront.net");
  if(source && !isCloudFrontUrl){
    sourceUrl = `${sourceUrl}&access_token=${AuthService.getAccessToken()}`;
  }

  return (
    <div id={`viewer_${asset.id}`} className={cx(styles.viewer, {[styles.modalOpened]: isSidePanelOpen} )}>
    {(_.get(preview, 'pages') || !preview) && (
      <Suspense fallback={<div></div>}>
        <DocumentViewer
          id={`asset_viewer_${asset.id}`}
          loading={preview && preview.loading || processingAsset}
          loadingComponent={() => {
            return (
              <div className={styles.loading}>
                <img src={loadingPlane} />
                <div className={styles.message}>Loading viewer...</div>
              </div>
            );
          }}
          initialPage={initialPage}
          sourceUrl={sourceUrl}
          previewData={preview}
          fetchPreviewData={() => {
            return loadPreviewData(asset);
          }}
          scrollParent={`.${styles.viewer}`}
          offset={offset}
          preferredWidth={preferredWidth}
          workerUrl={`https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.min.js`}
          onPageChange={(page) => onPageChange(page)}
          disabled={false}
          onError={handleError}
          hasTableOfContents={_.size(tableOfContent) > 0}
          handleTableOfContentsClick={() => setShowTableOfContents(!showTableOfContents)}
        />
      </Suspense>
    )}
    </div>
  );
};

export default EnhancedDocumentViewer;
